<template>
  <div class="welcomebox">
    <div class="header">
      <div class="header_box1">
        <p>产品数量</p>
        <p class="number">{{ news }}<span class="txt">个</span></p>
        <div class="icon">
          <span class="el-icon-tickets"></span>
        </div>
      </div>
      <div class="header_box2">
        <p>客户数量</p>
        <p class="number">{{ menu1 }}<span class="txt">个</span></p>
        <div class="icon">
          <span class="el-icon-chat-line-square"></span>
        </div>
      </div>
      <div class="header_box3">
        <p>订单数量</p>
        <p class="number">{{ users }}<span class="txt">个</span></p>
        <div class="icon">
          <span class="el-icon-thumb"></span>
        </div>
      </div>
      <div class="header_box4">
        <p>申请收集数量</p>
        <p class="number">{{ users }}<span class="txt">人</span></p>
        <div class="icon">
          <span class="el-icon-s-custom"></span>
        </div>
      </div>
      <div class="header_box5" hidden>
        <p>客户统计</p>
        <p class="number">2302<span class="txt">条</span></p>
        <div class="icon">
          <span class="el-icon-message"></span>
        </div>
      </div>
    </div>
    <div class="echarts_box">
      <div>
        一周访问量
        <StackChart></StackChart>
      </div>
      <div>
        一周申请贷款数量
        <Referchart></Referchart>
      </div>
      <div>
        地区访问分布
        <Barchart></Barchart>
      </div>
    </div>
  </div>
</template>

<script>
import Barchart from "./echarts/BarChart.vue";
import StackChart from "./echarts/StackChart.vue";
import Referchart from "./echarts/RefererChart.vue";
export default {
  components: {
    Barchart,
    Referchart,
    StackChart,
  },
  data() {
    return {
      news: "",
      menu1: "",
      menu2: "",
      users: "",
    };
  },
  methods: {
    search() {
      this.$httpPost({
        url: "/wlw_manage/nmw_count.aspx",
        data: {},
      }).then((res) => {
        this.news = res.news;
        this.menu1 = res.menu1;
        this.menu2 = res.menu2;
        this.users = res.users;
      });
    },
  },
  mounted() {
    this.search();
  },
};
</script>

<style lang="less" scoped>
.welcomebox {
  .header {
    display: flex;
    align-items: baseline;
    width: 100%;
    color: #fff;
    div {
      flex: 1;
      margin-left: 15px;
      border-radius: 5px;
      padding: 15px;
      position: relative;
      font-size: 14px;
      line-height: 28px;
      .icon {
        position: absolute;
        right: 15px;
        top: 19px;
        width: 36px;
        height: 37px;
        border-radius: 25px;
        background: rgba(0, 0, 0, 0.3);
        padding: 0;
        font-size: 26px;
        padding-top: 8px;
        padding-left: 9px;
      }
      .number {
        font-size: 20px;
        .txt {
          font-size: 14px;
        }
      }
    }
    .header_box1 {
      background: #4089e5;
      margin-left: 0px;
    }
    .header_box2 {
      background: #ebba44;
    }
    .header_box3 {
      background: #22bc9a;
    }
    .header_box4 {
      background: #ff6968;
    }
    .header_box5 {
      background: #ab73e2;
    }
  }
  .echarts_box {
    // width: calc(100% - 240px);
    display: flex;
    align-items: baseline;
    margin-top: 30px;
    div {
      flex: 1;
      padding: 10px;
      background: #fff;
      margin-right: 15px;
      text-align: center;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/main_home.vue